import { useEffect, RefObject } from 'react'

/**
 * Custom hook that detects clicks outside of specified element(s)
 *
 * @param refs - Single ref or array of refs to check for outside clicks
 * @param handler - Callback function to execute when click is outside
 * @param enabled - Whether the hook is enabled (default: true)
 */
export const useClickOutside = (
  refs: RefObject<HTMLElement> | RefObject<HTMLElement>[],
  handler: (event: MouseEvent) => void,
  enabled: boolean = true
) => {
  useEffect(() => {
    if (!enabled) return

    const handleClickOutside = (event: MouseEvent) => {
      const refsArray = Array.isArray(refs) ? refs : [refs]
      const isClickOutside = refsArray.every((ref) => ref?.current && !ref?.current?.contains(event.target as Node))

      if (isClickOutside) {
        handler(event)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [refs, handler, enabled])
}
